import React, { createContext, useContext, useState, ReactNode } from 'react';

// Define the type for the company data context
type CompanyData = {
  companyData: any; // Replace 'any' with a more specific type according to your data structure
  setCompanyData: React.Dispatch<React.SetStateAction<any>>; // Similarly, replace 'any' with the specific type
};

// Create the context with a default value
export const CompanyDataContext = createContext<CompanyData>({
  companyData: null, // Initial state
  setCompanyData: () => {}, // Placeholder function
});

// Define the type for the CompanyDataProvider props
type CompanyDataProviderProps = {
  children: ReactNode;
};

export const CompanyDataProvider = ({ children }: CompanyDataProviderProps) => {
  const [companyData, setCompanyData] = useState<any>(null); // Replace 'any' with the specific type of your company data

  return (
    <CompanyDataContext.Provider value={{ companyData, setCompanyData }}>
      {children}
    </CompanyDataContext.Provider>
  );
};

// Custom hook to use the company data context
export const useCompanyData = () => useContext(CompanyDataContext);
